module.exports = __webpack_public_path__ + "img/success.dcede9f3.gif";